import "core-js/modules/es.array.push.js";
import Bus from '@/assets/js/bus.js';
import axios from 'axios';
import { mapState } from 'vuex';
const CancelToken = axios.CancelToken;
export default {
  props: {
    outputRtilCode: [String, Number],
    devicePeerId: [String, Number],
    mainWindowDeviceType: [String, Number],
    slotNum: [String, Number],
    receiverNicknames: String,
    partyCode: [String, Number],
    partyInfo: Object,
    nickNameInfo: Object,
    mainWindowList: Array,
    pageNum: [String, Number]
  },
  data() {
    return {
      typeMap: {
        Receiver: 'receiver',
        Producer: 'producer',
        Pack: 'pack',
        Channel: 'channel',
        MediaHub: 'mediaHub'
      },
      outputSourceType: 'receiver',
      nickName: '',
      getDeviceParams: {
        pageNum: 1,
        pageSize: 20,
        living: true,
        offline: false,
        online: true,
        condition: '',
        queryCollaborate: true
      },
      encoderInfo: {
        visible: false,
        data: [],
        maxNumber: 1
      },
      selectOutputType: 'receiver',
      selectOutput: '',
      mainwindowId: '',
      // 正在MainWindow播出的源id
      mainwindowType: '',
      // 正在MainWindow播出的源type
      outputList: [],
      sourceVfbType: {
        show: false
      },
      liveLoading: false,
      sendReceiverInfo: {},
      changeSourceParams: {
        receiver: 'Receiver',
        producer: 'Producer',
        pack: 'Pack',
        channel: 'Channel',
        mediaHub: 'MediaHub'
      },
      listScroll: {
        distance: 15,
        directive: '.selectBox .el-scrollbar__wrap',
        onScroll: this.loadNextPage
      },
      receiverListInfo: {},
      packListInfo: {},
      mediaHubListInfo: {},
      cancel: {}
    };
  },
  computed: {
    ...mapState({
      Config: state => state.config,
      State: state => state,
      ChannelMode: state => state.channelMode
    }),
    sendBtnColor() {
      let color = 'gray';
      if (!this.selectOutput) {
        color = 'gray';
      }
      if (this.selectOutput) {
        color = 'green';
      }
      if (this.selectOutput && this.selectOutput == this.mainwindowId) {
        color = 'red';
      }
      return color;
    },
    returnNoData() {
      let noData = '';
      if (this.selectOutputType === 'producer') {
        noData = this.$t('common.noProgram');
      } else {
        noData = this.$t('common.noMainWinDowData');
      }
      return noData;
    }
  },
  watch: {
    devicePeerId: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.mainwindowId = newVal;
        this.selectOutput = newVal;
      }
    },
    mainWindowDeviceType: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.mainwindowType = newVal;
          this.selectOutputType = this.typeMap[newVal] || 'receiver';
          this.getOutputList('getDeviceList');
        }
      }
    }
  },
  methods: {
    setOptionWidth(event) {
      this.$nextTick(() => {
        const vfbSelectWidth = event.srcElement.offsetWidth;
        document.documentElement.style.setProperty('--vfbSelect-width', `${vfbSelectWidth}px`);
      });
    },
    returnNameByDeviceType(obj) {
      let nickName;
      switch (this.selectOutputType) {
        case 'pack':
          nickName = this.sourceVfbType.name + '_' + obj.source;
          break;
        case 'receiver':
          nickName = this.sourceVfbType.name + '_' + obj.source + `_${obj.channelCount}`;
          break;
        case 'producer':
          nickName = this.sourceVfbType.name + '_' + obj.sourceType;
          break;
        case 'channel':
          nickName = this.sourceVfbType.channelName + '_' + (obj.sourceType === 'RtilChannelPGM' ? 'Channel Output' : obj.sourceType);
          break;
      }
      return nickName;
    },
    changeMainWindowType() {
      if (this.selectOutputType == this.typeMap[this.mainwindowType]) {
        this.selectOutput = this.mainwindowId;
      } else {
        this.selectOutput = '';
        this.outputList = [];
      }
      this.getDeviceParams = {
        pageNum: 1,
        pageSize: 20,
        living: true,
        offline: false,
        online: true,
        condition: '',
        queryCollaborate: true
      };
      this.receiverListInfo = {};
      this.packListInfo = {};
      this.mediaHubListInfo = {};
      this.getOutputList(true);
    },
    getOutputList(type, visiable, val) {
      this.getDeviceList(type, '', visiable, val);
    },
    loadNextPage() {
      if (this.selectOutputType === 'receiver' && this.receiverListInfo.hasNextPage) {
        this.getDeviceList('getDeviceList', 'loadNextReceiverPage');
      } else if (this.selectOutputType === 'pack' && this.packListInfo.hasNextPage) {
        this.getDeviceList('getDeviceList', 'loadNextPackPage');
      } else if (this.selectOutputType === 'mediaHub' && this.mediaHubListInfo.totalNum > this.outputList.length) {
        this.getDeviceList('getDeviceList', 'loadNextMediaHubPage');
      }
    },
    getDeviceList(type, loadNextPage, visiable, val) {
      if (type === 'filter') {
        this.cancel.getDeviceList();
      }
      loadNextPage ? this.getDeviceParams.pageNum++ : this.getDeviceParams.pageNum = 1;
      if (visiable) {
        this.getDeviceParams.condition = '';
      } else {
        this.getDeviceParams.condition = val;
      }
      const _this = this;
      if (this.selectOutputType == 'producer' || this.selectOutputType == 'channel') {
        if (this.selectOutputType == 'channel') {
          this.getDeviceParams.origin = 'channel';
        }
      } else if (this.selectOutputType == 'mediaHub') {
        this.getDeviceParams.orderItem = {
          key: 'liveFirst',
          desc: true
        };
        const {
          online,
          offline,
          living,
          ...rest
        } = this.getDeviceParams;
        rest.pageSize = 20;
        this.getDeviceParams = rest;
      }
      let url = '/partyline-backend/receiver/v3/page';
      if (this.selectOutputType == 'pack') {
        url = '/partyline-backend/pack/page';
      } else if (this.selectOutputType == 'mediaHub') {
        url = `${this.Config.urlInfo.mediaHubServiceUrl}/media-hub/source/sourceListFromSearch`;
      } else {
        url = '/partyline-backend/receiver/v3/page';
      }
      this.axios.post(url, this.getDeviceParams, {
        cancelToken: new CancelToken(function executor(c) {
          _this.cancel.getDeviceList = c;
        })
      }).then(res => {
        if (res && res.data.errorCode === '0x0') {
          var _this$outputList;
          const result = res.data.result;
          if (this.selectOutputType === 'receiver') {
            this.receiverListInfo = result === null || result === void 0 ? void 0 : result.cc;
            if (loadNextPage == 'loadNextReceiverPage') {
              this.outputList = this.outputList.concat(result.cc.list);
            } else {
              this.outputList = result === null || result === void 0 ? void 0 : result.cc.list;
            }
          } else if (this.selectOutputType === 'pack') {
            this.packListInfo = result;
            if (loadNextPage == 'loadNextPackPage') {
              this.outputList = this.outputList.concat(result.list);
            } else {
              this.outputList = result.list;
            }
          } else if (this.selectOutputType === 'producer') {
            const ppList = result === null || result === void 0 ? void 0 : result.pps;
            const array = [];
            ppList === null || ppList === void 0 ? void 0 : ppList.forEach(item => {
              item.pageInfo.list.forEach(item1 => {
                array.push({
                  ...item.user,
                  ...item1
                });
              });
            });
            this.outputList = array;
          } else if (this.selectOutputType === 'channel') {
            this.outputList = result.channel || [];
          } else {
            // mediaHub
            this.mediaHubListInfo = result;
            if (loadNextPage == 'loadNextMediaHubPage') {
              this.outputList = this.outputList.concat(result === null || result === void 0 ? void 0 : result.sourceList);
            } else {
              this.outputList = result.sourceList || [];
            }
          }
          (_this$outputList = this.outputList) === null || _this$outputList === void 0 ? void 0 : _this$outputList.forEach(val => {
            val.mainwindowId = val.peerId || val.receiverId || val.pid || val.objectId;
          });
        }
      });
    },
    // 下拉选项选中 弹出弹窗
    async showVfbDialog(item, type) {
      this.sourceVfbType = {
        ...item,
        show: false
      };
      if (this.selectOutputType == 'receiver') {
        this.sourceVfbType.sourceType = 'receiver';
        this.sourceVfbType.params = {
          receiverId: item.mainwindowId
        };
        this.getEncoderInfo();
        this.sourceVfbType.currentRId = item.mainwindowId;
        this.sendReceiverInfo.outputRid = this.mainwindowId;
        // 这里还需后端添加记录选择的是哪个source
        this.sendReceiverInfo.outputSourceType = this.partyInfo.status ? this.partyInfo.status.outputSource : this.globalMainInfo.outputSource;
      } else if (this.selectOutputType == 'producer') {
        this.sourceVfbType.sourceType = 'PGM';
        this.sourceVfbType.productionId = item.id;
        this.sourceVfbType.params = {
          receiverId: item.mainwindowId
        };
        this.sourceVfbType.show = true;
      } else if (this.selectOutputType == 'pack') {
        // Pack只添加SDI IN/HDMI IN
        this.sourceVfbType.sourceType = 'pack';
        this.sourceVfbType.params = {
          receiverId: item.mainwindowId
        };
        this.sourceVfbType.show = true;
      } else if (this.selectOutputType == 'mediaHub') {
        if (type) {
          this.StartReceiverParty();
        }
      } else if (this.selectOutputType == 'channel') {
        this.sourceVfbType.sourceType = 'channel';
        this.sourceVfbType.params = {
          receiverId: item.mainwindowId
        };
        this.getEncoderInfo();
      }
    },
    getEncoderInfo() {
      this.liveLoading = true;
      this.axios.get(`/partyline-backend/receiver/encoder?rid=${this.sourceVfbType.params.receiverId}`, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          // interview 由于channel/receiver在线不一定可以正常使用
          this.liveLoading = false;
          if (!res) return;
          const result = res.data.result;
          this.sourceVfbType.encoderData = result;
          this.sourceVfbType.show = true;
        } else {
          this.liveLoading = false;
          this.$message.error(this.$t('galleryHost.isNotStarted'));
        }
      }).catch(e => {
        this.liveLoading = false;
        console.log(e);
      });
    },
    updateVfbData(obj) {
      if (obj.operateType == 'stop') {
        this.stopReceiverParty(obj);
      } else if (obj.operateType == 'send') {
        this.StartReceiverParty(obj);
      }
    },
    async controlOutput() {
      const _this = this;
      if (_this.sendBtnColor == 'gray') return;
      if (_this.sendBtnColor == 'red') {
        _this.stopReceiverParty();
      } else {
        const sourceData = {
          ...this.sourceVfbType,
          mainwindowId: this.selectOutput
        };
        this.showVfbDialog(sourceData, 'sendBtn');
      }
    },
    async stopReceiverParty(obj = {}) {
      let params = {};
      params = {
        partyCode: this.partyCode,
        slotNum: this.slotNum,
        rtilCode: this.outputRtilCode
      };
      if (this.liveLoading) return;
      this.liveLoading = true;
      await this.axios.post('/partyline-backend/interview/stopMainWindow', params).then(res => {
        this.liveLoading = false;
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.stopSucc'));
          // 用于关闭选择vfb type的弹窗
          obj.callback && obj.callback(obj);
          this.partyInfo.status.outputSource = '';
          this.partyInfo.status.outputId = '';
          this.partyInfo.status.output = '';
        }
      }).catch(() => {
        this.liveLoading = false;
      });
    },
    StartReceiverParty(obj = {}) {
      if (!this.partyCode || this.sendBtnColor != 'green' && !obj.operateType) return;
      let params = {
        partyCode: this.partyCode,
        mainWindowType: this.changeSourceParams[this.selectOutputType],
        slotNum: this.slotNum
      };
      let url = '';
      switch (this.selectOutputType) {
        case 'receiver':
        case 'producer':
        case 'channel':
          url = '/partyline-backend/interview/startMainWindow';
          params.receiverSource = {
            receiverId: this.selectOutput,
            source: obj.source,
            trackIds: obj.trackIds,
            nickName: this.returnNameByDeviceType(obj)
          };
          break;
        case 'pack':
          url = '/partyline-backend/interview/startPackMainWindow';
          params = {
            ...params,
            peerId: this.selectOutput,
            autoRecovery: 0,
            nickName: this.returnNameByDeviceType(obj)
          };
          break;
        case 'mediaHub':
          url = '/partyline-backend/interview/startMediaHubMainWindow';
          params = {
            ...params,
            objectId: this.selectOutput,
            nickName: this.sourceVfbType.objectName
          };
          break;
      }
      if (!this.selectOutput || this.liveLoading) return;
      this.liveLoading = true;
      this.axios.post(url, params).then(res => {
        this.liveLoading = false;
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.sendSucc'));
          // 用于关闭选择vfb type的弹窗
          obj.callback && obj.callback(obj);
          this.partyInfo.status.outputSource = params.receiverSource ? params.receiverSource.sourceType : '';
          this.partyInfo.status.outputId = this.selectOutput || obj.currentRId;
        } else if (res.data.errorCode == '82201204') {
          const result = JSON.parse(res.data.errorInfo);
          const array = [];
          result.encoders.forEach(item => {
            const obj = {};
            obj.code = item.code;
            obj.title = item.title ? item.title : new Date(item.createTime).toLocaleDateString() + ' ' + new Date(item.createTime).toLocaleTimeString();
            obj.mode = this.ChannelMode[item.mode] ? this.ChannelMode[item.mode].toLowerCase() : '';
            if (item.loginUser) {
              obj.email = item.loginUser.email;
            }
            obj.outputSource = item.vfbSource;
            obj.realPartyCode = item.realPartyCode;
            obj.rid = this.selectOutput;
            obj.loginUser = item.loginUser;
            obj.globalControlId = item.globalControlId;
            obj.hasStop = false;
            obj.loading = false;
            array.push(obj);
          });
          this.encoderInfo.maxNumber = result.maxEncoderNumber;
          this.encoderInfo.data = array;
          this.encoderInfo.visible = true;
          this.sourceVfbType.show = false;
        }
      }).catch(() => {
        this.liveLoading = false;
      });
    }
  },
  beforeDestory() {
    Bus.$off('setOutput');
    Bus.$off('cancelOutput');
  }
};